import React from 'react'
import { connect } from 'react-redux'
import { Segment, Header, Grid, Loader  } from 'semantic-ui-react'
import _ from 'lodash'

import { Action } from '../redux/actions/types'
import { retrieveInitialData, retrieveMoreData, setCurrentRequest } from '../redux/actions'
import RequestList from '../components/RequestList'
import RequestDetail from './RequestDetail'

class Requests extends React.Component {
    
    constructor(props){
        super(props)
        this.state = {
            selected: 0
        }
    }

    componentDidMount() {   
        this.props.retrieveInitialData('requests', Action.REQUESTS_INITIAL, {
            field: 'date_created',
            order: 'desc'
        })
    }

    onSelectHandler = (selected) => {
        this.setState({
            selected
        })
        this.props.setCurrentRequest(selected)
    }

    retrieveMoreRequests = () => {
        //console.log("vamos a traer mas data")
        this.props.retrieveMoreData('requests', Action.REQUESTS_MORE, {
            field: 'date_created',
            order: 'desc'
        })
    }

    render() {
        //console.log("request: ", this.props.admin)
        //const { currentRequest } = this.props.admin
        const { loading, requestArray, currentIndex, lastPage } = this.props.requestList
        const { selected } = this.state
        //console.log("requests: ", admin)
        if (loading || requestArray.length === 0) {
            return (
                <Loader>Loading</Loader>
            )
        }
        // if (_.isEmpty(currentRequest)){
        //     this.props.setCurrentRequest(0)
        //     return null
        // }
        return (
            <Segment >
                <Header as='h3'>
                    Requests
                </Header>
                <Grid container>
                    <Grid.Row>
                        <Grid.Column width={4} style={{height: 500}} stretched>
                            <RequestList 
                                requestList={requestArray} 
                                lastPage={lastPage} 
                                selected={selected} 
                                onSelectHandler={this.onSelectHandler}
                                loading={loading}
                                requestMoreData={this.retrieveMoreRequests}
                            />
                        </Grid.Column>
                        <Grid.Column width={12} stretched>
                            <RequestDetail />
                        </Grid.Column> 
                    </Grid.Row>
                </Grid>
            </Segment>
        )
    }
}

const mapStateToProps = state => {
    //console.log("STATE: ", state)
    const { admin, requestList } = state
    return { admin, requestList }
}

export default connect(mapStateToProps, { retrieveInitialData, retrieveMoreData, setCurrentRequest })(Requests)